import { useEffect, useState, SetStateAction, Dispatch, useRef } from 'react';

import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import { getPath, Path } from 'components/_hooks/use-router';
import { useZoomCb } from 'components/app/_mediator/zoom/use-zoom-cb';
import { useAudioTrackContext } from 'components/app/audio-track/_mediator/audio-track.provider';
import { SNAPSHOT, Snapshot, setTracksRestored, setSnapshot } from './memory.slice';

export const useMemory = (snapshot: Snapshot | null, callBack?: () => void) => {
  const { wsSeekTo } = useAudioTrackContext();
  const { restoreSnapshot } = useZoomCb();
  const finalcuts = useAppSelector((state) => state.app__data.finalcuts);
  const projectLoaded = useAppSelector((state) => state.app.projectLoaded);
  const storyLoaded = useAppSelector((state) => state.app.storyLoaded);
  const waveIsReady = useAppSelector((state) => state.audio.waveIsReady);
  const finalcutId = useAppSelector((state) => state.fc__data.id);
  const dispatch = useAppDispatch();

  const [pageInit, setPageInit] = useState(false);

  useResetPageInit(pageInit, setPageInit);

  const handleRestore = () => {
    wsSeekTo(snapshot ? snapshot.cursorTime : 0);
    restoreSnapshot(snapshot ? snapshot : SNAPSHOT);
  };

  useEffect(() => {
    if (pageInit) return;
    if (projectLoaded && storyLoaded && waveIsReady && (finalcutId || !finalcuts.length)) setPageInit(true);
  }, [projectLoaded, storyLoaded, waveIsReady, finalcutId]);

  useEffect(() => {
    if (!pageInit) return;
    if (callBack) callBack();
    else handleRestore();
    dispatch(setTracksRestored());
  }, [pageInit]);
};

/* H O O K */

const useResetPageInit = (pageInit: boolean, setPageInit: Dispatch<SetStateAction<boolean>>) => {
  const { takeSnapshot } = useZoomCb();
  const selectedFinalcut = useAppSelector((state) => state.projects.selectedFinalcut);
  const selectedStory = useAppSelector((state) => state.projects.selectedStory);
  const pageInitRef = useRef(false);
  const dispatch = useAppDispatch();

  const isFc = () => getPath() === Path.finalcuts;

  const cb = () => {
    if (pageInitRef.current) dispatch(setSnapshot(takeSnapshot(), getPath()));
    setPageInit(false);
  };

  useEffect(() => {
    pageInitRef.current = pageInit;
  }, [pageInit]);

  /* selector or storyBoard pages */
  useEffect(() => {
    if (isFc()) return;
    return () => cb();
  }, [selectedStory]);

  /* finalCuts page */
  useEffect(() => {
    if (!isFc()) return;
    if (!selectedFinalcut) return;
    return () => cb();
  }, [selectedFinalcut]);
};
